import { Button } from '@mui/material'
import { FC } from 'react'
import { MUIButtonModel } from '../../../Models'
import { disableButtonBasedOnRole } from '../../../Helpers/Util'
import CONSTANTS from '../../../Constants'

const MUIButton: FC<MUIButtonModel> = ({
  id,
  type,
  label,
  variant,
  color,
  disabled,
  size = 'medium',
  fullWidth = false,
  className = '',
  handleClickCB,
  width = 200,
  height = 'fit-content',
  fontWeight = 500,
  fontSize = '',
  startIcon,
  endIcon,
  sx = {},
  testID,
  nonDisableProp = false,
}) => {
  const pathArray = window.location.pathname.split('/')
  const moduleAccess = disableButtonBasedOnRole(pathArray[1])

  return (
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={
        (!nonDisableProp &&
          CONSTANTS.SAVE_CTA_LABELS.some((text) => label.includes(text)) &&
          moduleAccess) ||
        disabled
      }
      color={color}
      variant={variant}
      fullWidth={fullWidth}
      type={type}
      size={size}
      data-testid={testID ?? id ?? label}
      sx={{
        ...sx,
        minWidth: width,
        height,
        fontWeight,
        fontSize,
      }}
      className={className}
      onClick={handleClickCB}
      id={id}
    >
      <span data-testid='button-test-spam' style={{ textTransform: 'none' }}>
        {' '}
        {label}
      </span>
    </Button>
  )
}

export default MUIButton
